import * as React from 'react';
import styled from 'styled-components';
import { rem, darken } from 'polished';
import { Button } from '../../Zemplin/General/Button';
import { IconImg } from '../../Defaults/Icon/IconImg';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';
import * as cartSrc from '../../../../assets/dsi/cart.svg';
import { __ } from 'react-i18n';

interface Props {
  onButtonClick: any;
  disabled?: boolean;
  avail_id: number;
}

function BigButtonWithRequest({ onButtonClick, disabled, avail_id }: Props) {
  console.log(avail_id);
  return (
    <Wrapper>
      <CartButton
        disabled={disabled}
        type="button"
        onClick={onButtonClick}
        avail_id={avail_id}
      >
        <IconImg
          disabled={disabled}
          cursor={'pointer'}
          src={cartSrc.toString()}
          alt="Pridať do košíka"
          marginRight={false}
        />
        <ToCartText>{__('Do košíka')}</ToCartText>
      </CartButton>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  position: relative;
  justify-content: flex-end;
  width: 100%;
  margin-right: ${rem(16)};
`;

const CartButton = styled(Button)<{ avail_id: number }>`
  background-color: ${({ theme, avail_id }) =>
    avail_id === 1
      ? theme.colors.stockCountAvailable
      : theme.colors.stockCountSold};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.white};
  font-weight: 300;

  &:hover {
    filter: brightness(90%);
    transition: filter 0.2s ease;
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.disabled};
  }

  ${({ theme }) => theme.mediab.l925`
    font-weight: 400;
  `}
`;

const ToCartText = styled.span`
  font-size: ${rem(20)};
  font-weight: 500;
  margin-left: ${rem(12)};
  display: flex;
  align-items: flex-end;
`;
export { BigButtonWithRequest };
